export default __webpack_public_path__ + "static/Gilroy-Regular-c78720ba66ffe58324e722d0d0043b17.woff2";